import { AxiosRequestConfig } from 'axios';
import axios from './axios';
import { UserPlanInterface } from './userPlan.interface';

export const user_plan_services = {
	getUserPlan,
};

/**
 * API call to check if the user has an active subscription/plan
 * This is the main API endpoint used throughout the app to verify subscription status
 * @param userId - The user's ID to check plan status for
 * @returns Promise<UserPlanInterface> - Contains user's plan details, subscription status, billing information
 * 
 * IMPORTANT: Response includes 'disabled' field - when set to true, user access is completely blocked
 * and a non-dismissible modal with support contact option is shown
 */
function getUserPlan(userId: string): Promise<UserPlanInterface> {
	return new Promise(async (resolve, reject) => {
		try {
			const config: AxiosRequestConfig = {
				method: 'get',
				url: '/user-plan', // Main API endpoint for subscription status check
				params: { userId },
			};
			const resp = await axios(config);
			const response = resp.data;
			resolve(response.data);
		} catch (error: any) {
			console.log('getUserPlan error: ', error);
			reject(error);
		}
	});
}
